/**
 * 详情 tab with nothing selected: how to read the canvas, and every program by category.
 */
import { Box, Button, SpaceBetween } from '@amzn/awsui-components-react';

import { PROGRAM_CATEGORY_META, type ProgramCategory, programCategoryOf } from '../../utils/programCategory';
import type { Projection } from '../../utils/projection';
import './SidePanel.css';

export interface CanvasLegendProps {
  projection: Projection;
  showingRules: boolean;
  onShowRules: () => void;
  onSelectNode: (id: string) => void;
}

export default function CanvasLegend({ projection, showingRules, onShowRules, onSelectNode }: CanvasLegendProps) {
  const programs = projection.nodes.filter((n) => n.kind === 'program');
  return (
    <SpaceBetween size="m">
      <ul className="cpa-legend">
        <li>点题卡 / 线 → 这里显示详情；点资格规则标签 → 这条规则；点项目 → 授予它的所有规则。</li>
        <li>题 → 规则 → 项目这条线就是一条资格规则，标签上写的是条件；红色 = 规则有缺陷。</li>
        <li>选中后，与它无关的元素变淡。「聚焦」模式只画选中项相关的规则和项目。</li>
        <li>
          URL 加 <code>?mode=dev</code> 换成原型的线形（题→题曲线、资格线末段曲线）。
        </li>
      </ul>
      {!showingRules ? (
        <SpaceBetween size="xs">
          <Box color="text-body-secondary">当前「只看问题」，画布上没有规则和项目。</Box>
          <Button onClick={onShowRules}>显示 题 → 规则 → 项目</Button>
        </SpaceBetween>
      ) : (
        (Object.keys(PROGRAM_CATEGORY_META) as ProgramCategory[]).map((c) => {
          const ps = programs.filter((p) => programCategoryOf(p.data.programName ?? '') === c);
          if (!ps.length) return null;
          const meta = PROGRAM_CATEGORY_META[c];
          return (
            <div key={c}>
              <Box variant="awsui-key-label">{meta.label}</Box>
              <div className="cpa-legend__chips">
                {ps.map((p) => (
                  <button
                    key={p.id}
                    type="button"
                    className="cpa-legend__chip"
                    style={{ borderColor: meta.color, color: meta.color }}
                    onClick={() => onSelectNode(p.id)}
                  >
                    {p.data.programName} ×{p.data.grantCount}
                  </button>
                ))}
              </div>
            </div>
          );
        })
      )}
    </SpaceBetween>
  );
}
